import { create } from 'zustand';

import { StateArticle } from '@/models/States';

export const articleStore = create<StateArticle>((set) => ({
  story: {
    opened: false,
  },
  updateStory: (opened: boolean) =>
    set((state) => ({ ...state, story: { ...state.story, opened } })),
}));
